import { render, staticRenderFns } from "./ChannelWait.vue?vue&type=template&id=5a0789d8&scoped=true&"
import script from "./ChannelWait.vue?vue&type=script&lang=js&"
export * from "./ChannelWait.vue?vue&type=script&lang=js&"
import style0 from "./ChannelWait.vue?vue&type=style&index=0&id=5a0789d8&prod&lang=css&"
import style1 from "./ChannelWait.vue?vue&type=style&index=1&id=5a0789d8&prod&scoped=true&lang=css&"
import style2 from "./ChannelWait.vue?vue&type=style&index=2&id=5a0789d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0789d8",
  null
  
)

export default component.exports